<template>
  <DialogWrapper :title="$t('project.duplicate.title')" overlayColor="#3776CB" @close-dialog="cancel" :dialog="popUpValue" :maxWidth="500">
    <template #subHeader>
      <v-card-subtitle class="first-letter-capital pt-5">
        <span class="hint">
          {{$t('project.duplicate.title')}}
          {{" "+ popUpValue.scenario.name +" "}}
          {{$t('project.duplicate.into')}}
          {{$t('one_project')}}:
        </span>
      </v-card-subtitle>
    </template>
    <v-row no-gutters>
      <v-select
        item-text="name"
        item-value="uuid"
        v-model="itemSelected"
        :items="items"
        hide-details
        dense
        return-object
      />
    </v-row>
    <template #actions>
      <v-row no-gutters justify="center">
        <div>
          <ActionButton label="clone"
                        @click="confirm"/>
        </div>
      </v-row>
    </template>
  </DialogWrapper>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FontIcon from '@/components/FontIcon.vue';
import DialogWrapper from '@/components/DialogWrapper.vue';
import ActionButton from '@/components/ActionButton.vue';

@Component({
  components: {
    ActionButton,
    FontIcon,
    DialogWrapper
  }
})
export default class DuplicationDialog extends Vue {
  @Prop({ required: false })
  public popUpValue: any;

  @Prop({ required: false })
  public itemsProp: any[] | undefined;

  public itemSelected: any = null;

  get items(): any[] | undefined {
    return this.itemsProp;
  }

  get defaultItem(): any {
    return this.itemsProp?.find(
      (e: any) => e.uuid === this.popUpValue.projectId
    );
  }

  // METHODS =======================================================

  private confirm() {
    this.$emit('confirm', {
      project: this.itemSelected,
      scenario: this.popUpValue.scenario
    });
  }

  private cancel() {
    this.$emit('cancel');
  }

  // HOOKS =======================================================
  @Watch('defaultItem', { immediate: true })
  private initSelectedItem() {
    this.itemSelected = this.itemsProp?.find(
      (e: any) => e.uuid === this.popUpValue.projectId
    );
  }
}
</script>

<style lang="stylus"></style>
